/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {MetricsApi} from '../metrics';
import Runtime from './Runtime';
import {SettingsApi} from '../settings';

interface Modules {
  readonly default: new (options?: any) => Runtime;
  readonly metrics: MetricsApi;
  runtime: Runtime;
  readonly settings: () => SettingsApi;
}

type Global = typeof window & {
  readonly 'exc-module-runtime': Modules;
  EXC_MR_READY: () => void;
};

export function getImpl<T extends keyof Modules>(moduleName: T): Modules[T] {
  const emr = (window as Global)['exc-module-runtime'];
  if (!emr) {
    throw new Error('module-runtime APIs not available.');
  }
  return emr[moduleName];
}

export default (window as Global);
